import React, { useState, useEffect, useReducer, useRef, useContext } from "react";

import { isSameDay, parseISO, format } from "date-fns";
import openSocket from "../../services/socket-io";
import clsx from "clsx";

import { green } from "@material-ui/core/colors";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {
  Button,
  CircularProgress,
  Divider,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import {
  AccessTime,
  Block,
  Done,
  DoneAll,
  ExpandMore,
  GetApp,
  PlayArrow,
  Photo,
  Videocam,
  Mic,
  InsertDriveFile,
  EmojiEmotions,
  ErrorOutline,
} from "@material-ui/icons";

import MarkdownWrapper from "../MarkdownWrapper";
import VcardPreview from "../VcardPreview";
import LocationPreview from "../LocationPreview";
import ModalImageCors from "../ModalImageCors";
import MessageOptionsMenu from "../MessageOptionsMenu";
import whatsBackground from "../../assets/wa-background.png";
import { formatarNomeOuTelefone } from "../../utils/phone";

import { toast } from "react-toastify";

import { MensagensPendentesContext } from "../../context/MensagensPendentes/MensagensPendentesContext";

import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import Audio from "../Audio";
import DocumentoMensagem from "../DocumentoMensagem";
import { poderDeAdmin } from "../../utils/perfil";

const useStyles = makeStyles((theme) => ({
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },

  messagesList: {
    // Mesmo desenho do WhatsApp nos dois modos.
    // Claro: "multiply" tinge o bege de verde clarinho.
    // Escuro: "difference" inverte a imagem (bege #E5DDD5) contra #F5FDEF:
    // o fundo vira verde-escuro (#13201f) e os desenhos ficam mais CLAROS que
    // ele, como no WhatsApp escuro. Com multiply ficava tudo quase preto.
    backgroundImage: `url(${whatsBackground})`,
    backgroundColor: theme.palette.type === "dark" ? "#f5fdef" : "#e6f2ea",
    backgroundBlendMode: theme.palette.type === "dark" ? "difference" : "multiply",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 20px 20px",
    overflowY: "scroll",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "90px",
    },
    ...theme.scrollbarStyles,
  },

  circleLoading: {
    color: green[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",





    flexShrink: 0,
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.type === "dark" ? "#1e293b" : "#ffffff",
    color: theme.palette.type === "dark" ? "#e6f4ec" : "#1f293b",
    alignSelf: "flex-start",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 14,
    borderBottomLeftRadius: 14,
    borderBottomRightRadius: 14,
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 6,
    paddingBottom: 0,
    boxShadow: theme.palette.type === "dark"
      ? "0 2px 6px rgba(0,0,0,0.35)"
      : "0 2px 6px rgba(10,38,36,0.08)",
    border: theme.palette.type === "dark" ? "1px solid rgba(255,255,255,0.04)" : "1px solid #edf2ef",
    animation: "iaSubir .25s ease backwards",
  },

  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: theme.palette.type === "dark" ? "#1f2c34" : "#f0f0f0",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",




    flex: 1,
    minWidth: 0,
  },






  quotedMiniatura: {
    width: 52,
    height: 52,
    objectFit: "cover",
    flexShrink: 0,
    display: "block",
    alignSelf: "center",
    marginRight: 4,
    borderRadius: 4,
  },

  quotedRotulo: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    opacity: 0.85,
    fontSize: "0.82rem",
  },

  quotedRotuloIcone: {
    fontSize: 15,
  },




  quotedClicavel: {
    cursor: "pointer",
    "&:hover": { filter: "brightness(0.96)" },
  },






  "@keyframes piscarMensagem": {
    "0%":   { boxShadow: "0 2px 6px rgba(10,38,36,0.08)" },
    "25%":  { boxShadow: "0 0 0 3px rgba(13,148,136,0.65)" },
    "60%":  { boxShadow: "0 0 0 3px rgba(13,148,136,0.65)" },
    "100%": { boxShadow: "0 2px 6px rgba(10,38,36,0.08)" },
  },

  mensagemDestacada: {
    animation: "$piscarMensagem 1.2s ease-in-out",
  },




  bolhaPendente: {
    opacity: 0.72,
  },

  avisoFalha: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginTop: 4,
    fontSize: "0.72rem",
    color: "#c0392b",
  },

  botaoReenviar: {
    border: "none",
    background: "none",
    padding: 0,
    fontSize: "0.72rem",
    fontWeight: 700,
    color: "#0D9488",
    cursor: "pointer",
    textDecoration: "underline",
    fontFamily: "inherit",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageRight: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",





    flexShrink: 0,
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.type === "dark" ? "#11643c" : "#d4f6dc",
    color: theme.palette.type === "dark" ? "#eafff2" : "#1f293b",
    alignSelf: "flex-end",
    borderTopLeftRadius: 14,
    borderTopRightRadius: 14,
    borderBottomLeftRadius: 14,
    borderBottomRightRadius: 4,
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 6,
    paddingBottom: 0,
    boxShadow: theme.palette.type === "dark"
      ? "0 2px 6px rgba(0,0,0,0.35)"
      : "0 2px 6px rgba(13,148,136,0.12)",
    animation: "iaSubir .25s ease backwards",
  },

  messageRightComunicado: {
    backgroundColor: theme.palette.type === "dark" ? "#3d1830" : "#ffe6f3",
    color: theme.palette.type === "dark" ? "#f7d6e8" : "#7a1650",
    
    borderBottomRightRadius: 8
  },
  comunicadoTitulo: {
    display: "block",
    fontSize: "0.7rem",
    fontWeight: 800,
    letterSpacing: 1.2,
    textTransform: "uppercase",
    opacity: 0.9,
    marginBottom: 2
  },
  comunicadoAutor: {
    display: "block",
    fontSize: "0.72rem",
    fontStyle: "italic",
    opacity: 0.8,
    marginBottom: 6
  },
  messageRightNota: {
    backgroundColor: theme.palette.type === "dark" ? "#3d3218" : "#fff5d6",
    color: theme.palette.type === "dark" ? "#f0e3c0" : "#5a4a18",
    borderLeft: `4px solid ${theme.palette.type === "dark" ? "#c9a227" : "#e0b83a"}`,
    borderBottomRightRadius: 8
  },

  messageRightDev: {
    backgroundColor: theme.palette.type === "dark" ? "#3a1f1f" : "#fdecec",
    color: theme.palette.type === "dark" ? "#f3b7b7" : "#8c2f2f",
    borderLeft: `4px solid ${theme.palette.type === "dark" ? "#c0392b" : "#e57373"}`,
    borderBottomRightRadius: 8,
    fontSize: "0.8rem"
  },
  linkDetalhes: {
    // block, nao inline-block: o corpo da nota e renderizado como texto
    // corrido, entao o botao colava na ultima palavra ("...iniciar
    // propostaver detalhes"). A linha em cima separa o rastro tecnico da
    // mensagem do banco.
    display: "block",
    width: "fit-content",
    marginTop: 8,
    background: "none",
    // ordem importa: o reset vem antes, senao ele apaga a linha de cima.
    border: "none",
    borderTop: "1px solid rgba(0,0,0,0.15)",
    padding: "6px 0 0 0",
    fontSize: "0.74rem",
    fontWeight: 600,
    textDecoration: "underline",
    cursor: "pointer",
    fontFamily: "inherit",
    color: "inherit",
    opacity: 0.85,
    "&:hover": { opacity: 1 }
  },
  jsonCru: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontFamily: "monospace",
    fontSize: "0.78rem",
    lineHeight: 1.5,
    margin: 0
  },

  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: theme.palette.type === "dark" ? "#0b4a2c" : "#c2ecce",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  messageActionsButton: {
    display: "none",
    position: "relative",
    color: "#999",
    zIndex: 1,
    backgroundColor: "inherit",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "inherit" },
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.36)",
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },







  bolhaComMidia: {
    width: 262,
    minWidth: 262,
    maxWidth: 262,






    "& $quotedContainerLeft, & $quotedContainerRight": {
      marginRight: 0,
    },
  },







  bolhaFigurinha: {
    backgroundColor: "transparent",
    boxShadow: "none",
    minWidth: 0,
    width: "auto",
    maxWidth: 180,
    paddingLeft: 0,
    paddingRight: 0,
  },

  figurinha: {
    width: 140,
    height: 140,
    objectFit: "contain",
    display: "block",
    backgroundColor: "transparent",
  },




  molduraVideo: {
    position: "relative",
    width: 250,
    height: 200,
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "#000",
    display: "block",
  },

  videoDentro: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
    backgroundColor: "#000",
  },

  botaoPlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 56,
    height: 56,
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    transition: "background-color 0.15s ease",

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  },




  textContentItemMidia: {
    padding: "3px 6px 20px 6px",
  },




  textContentItemFigurinha: {
    padding: "0 6px 16px 6px",
  },






  textContentItemAudio: {
    padding: "0 6px 18px 6px",
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 0,
    right: 5,
    color: "#999",
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: theme.palette.type === "dark" ? "#182229" : "#e1f3fb",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "0 1px 1px #b3b3b3",
  },

  dailyTimestampText: {
    color: theme.palette.type === "dark" ? "#8696a0" : "#808888",
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  

  
  ackDoneAllIcon: {
    color: "#53bdeb",
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  downloadMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
  },
}));

const reducer = (state, action) => {
  if (action.type === "LOAD_MESSAGES") {
    const messages = action.payload;
    const newMessages = [];

    messages.forEach((message) => {
      const messageIndex = state.findIndex((m) => m.id === message.id);
      if (messageIndex !== -1) {
        state[messageIndex] = message;
      } else {
        newMessages.push(message);
      }
    });

    return [...newMessages, ...state];
  }

  // Depois de uma queda do tempo real: junta o que faltou e reordena.
  if (action.type === "SINCRONIZAR_MESSAGES") {
    const novas = action.payload || [];
    novas.forEach((message) => {
      const i = state.findIndex((m) => m.id === message.id);
      if (i !== -1) state[i] = message;
      else state.push(message);
    });
    return [...state].sort(
      (a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0)
    );
  }

  if (action.type === "ADD_MESSAGE") {
    const newMessage = action.payload;
    const messageIndex = state.findIndex((m) => m.id === newMessage.id);

    if (messageIndex !== -1) {
      state[messageIndex] = newMessage;
    } else {
      state.push(newMessage);
    }

    return [...state];
  }

  // O autor esta copiado dentro de cada mensagem que ele mandou. Trocar a foto
  // no perfil emite so o usuario: sem isto, as mensagens ja carregadas
  // continuariam com a foto velha ate a conversa ser aberta de novo.
  if (action.type === "UPDATE_AUTOR_DAS_MENSAGENS") {
    const usuario = action.payload;
    let mudou = false;

    state.forEach((mensagem, i) => {
      if (mensagem.user?.id !== usuario.id) return;
      state[i] = { ...mensagem, user: { ...mensagem.user, ...usuario } };
      mudou = true;
    });

    return mudou ? [...state] : state;
  }

  if (action.type === "UPDATE_MESSAGE") {
    const messageToUpdate = action.payload;
    const messageIndex = state.findIndex((m) => m.id === messageToUpdate.id);

    if (messageIndex !== -1) {
      state[messageIndex] = messageToUpdate;
    }

    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const ehNotaInterna = (message) =>
  typeof message?.body === "string" && message.body.startsWith("🔒 _Nota interna_");

const ehNotaDev = message => Boolean(message?.isDevNote);

// Comunicado da equipe: mora dentro da conversa do cliente, mas o cliente
// nunca recebe — a mensagem nasce só no banco.
const ehComunicado = message => Boolean(message?.isComunicado);







const ehFigurinha = (message) => {
  if (!message?.mediaUrl) return false;
  if (message.mediaType === "sticker") return true;




  return (
    message.mediaType === "image" && /\.webp(\?.*)?$/i.test(message.mediaUrl)
  );
};




const ehImagem = (message) =>
  message?.mediaType === "image" && !!message.mediaUrl;








const resumoDaCitacao = (citada) => {
  if (!citada?.mediaUrl) return null;

  if (ehFigurinha(citada)) {
    return { rotulo: "Figurinha", Icone: EmojiEmotions };
  }

  if (citada.mediaType === "image") {
    return { rotulo: "Foto", Icone: Photo };
  }

  if (citada.mediaType === "video") {
    return { rotulo: "Vídeo", Icone: Videocam };
  }

  if (citada.mediaType === "audio") {
    return { rotulo: "Áudio", Icone: Mic };
  }

  if (citada.mediaType === "location") return null;
  if (citada.mediaType === "vcard") return null;

  return { rotulo: "Documento", Icone: InsertDriveFile };
};




const temMiniaturaNaCitacao = (citada) =>
  !!citada?.mediaUrl &&
  (citada.mediaType === "image" || citada.mediaType === "sticker");




const VideoMensagem = ({ url, classes }) => {
  const videoRef = useRef(null);
  const [tocando, setTocando] = useState(false);

  const play = () => {
    setTocando(true);
    const el = videoRef.current;
    if (el) {
      el.play().catch(() => {

        setTocando(false);
      });
    }
  };

  return (
    <div className={classes.molduraVideo}>
      <video
        ref={videoRef}
        className={classes.videoDentro}
        src={url}
        controls={tocando}
        preload="metadata"
        playsInline
        onPause={() => setTocando(true)}
      />
      {!tocando && (
        <button
          type="button"
          className={classes.botaoPlay}
          onClick={play}
          aria-label="Reproduzir vídeo"
        >
          <PlayArrow style={{ fontSize: 34 }} />
        </button>
      )}
    </div>
  );
};




const LIMITE_REENVIO_MS = 5 * 60 * 1000;

const MessagesList = ({ ticketId, isGroup }) => {

  const [detalheDev, setDetalheDev] = useState(null);





  const { user: usuarioLogado } = useContext(AuthContext);

  const { doTicket, remover, marcarFalha, marcarEnviando } = useContext(
    MensagensPendentesContext
  );

  const pendentesDoTicket = doTicket(ticketId);











  const [taxaAudio, setTaxaAudio] = useState(() =>
    parseFloat(localStorage.getItem("audioMessageRate") || "1")
  );

  const alterarTaxaAudio = (nova) => {
    setTaxaAudio(nova);
    localStorage.setItem("audioMessageRate", nova);
  };

  const [, forcarRedesenho] = useState(0);

  useEffect(() => {
    if (!pendentesDoTicket.length) return undefined;

    const timer = setInterval(() => forcarRedesenho(n => n + 1), 15000);
    return () => clearInterval(timer);
  }, [pendentesDoTicket.length]);

  const reenviar = async (pendente) => {
    marcarEnviando(pendente.tempId);
    try {
      await api.post(`/messages/${pendente.ticketId}`, pendente.payload);
      remover(pendente.tempId);
    } catch (err) {
      marcarFalha(pendente.tempId, err?.message);
    }
  };
  const classes = useStyles();

  const [messagesList, dispatch] = useReducer(reducer, []);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const lastMessageRef = useRef();

  const [selectedMessage, setSelectedMessage] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const messageOptionsMenuOpen = Boolean(anchorEl);
  const currentTicketId = useRef(ticketId);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);

    currentTicketId.current = ticketId;
  }, [ticketId]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchMessages = async () => {
        try {
          const { data } = await api.get("/messages/" + ticketId, {
            params: { pageNumber },
          });

          if (currentTicketId.current === ticketId) {
            dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
            setHasMore(data.hasMore);
            setLoading(false);
          }

          if (pageNumber === 1 && data.messages.length > 1) {
            scrollToBottom();
          }
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchMessages();
    }, 500);
    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [pageNumber, ticketId]);

  useEffect(() => {
    const socket = openSocket();

    // Busca as mensagens recentes e junta com as da tela (sem piscar).
    const sincronizar = async () => {
      try {
        const { data } = await api.get("/messages/" + ticketId, { params: { pageNumber: 1 } });
        if (currentTicketId.current !== ticketId) return;
        dispatch({ type: "SINCRONIZAR_MESSAGES", payload: data.messages });
      } catch (err) {
        /* tenta de novo na proxima reconexao */
      }
    };

    // O tempo real caiu e voltou: o que chegou nesse meio-tempo nao veio pelo
    // socket. Antes so aparecia ao reabrir a conversa ou dar F5.
    let jaConectou = socket.connected;
    const onConnect = () => {
      socket.emit("joinChatBox", ticketId);
      if (jaConectou) sincronizar();
      jaConectou = true;
    };
    socket.on("connect", onConnect);
    if (socket.connected) {
      socket.emit("joinChatBox", ticketId);
    }

    // Aba que ficou um tempo escondida (o Chrome congela abas paradas)
    let escondidaDesde = 0;
    const aoMudarVisibilidade = () => {
      if (document.visibilityState === "hidden") {
        escondidaDesde = Date.now();
      } else if (escondidaDesde && Date.now() - escondidaDesde > 30000) {
        sincronizar();
      }
    };
    document.addEventListener("visibilitychange", aoMudarVisibilidade);

    const onAppmessage = (data) => {
      // Nota do programador so para admin. Ela chega na sala do ticket como
      // qualquer mensagem; quem filtra por perfil e a tela.
      if (data.message?.isDevNote && !poderDeAdmin(usuarioLogado?.profile)) {
        return;
      }

      if (
        data.action === "create" &&
        data.message.ticketId.toString() === ticketId
      ) {
        dispatch({ type: "ADD_MESSAGE", payload: data.message });
        scrollToBottom();
      }

      if (
        data.action === "update" &&
        data.message.ticketId.toString() === ticketId
      ) {
        dispatch({ type: "UPDATE_MESSAGE", payload: data.message });
      }
    };
    const onUser = (data) => {
      if (data.action === "update" && data.user?.id) {
        dispatch({ type: "UPDATE_AUTOR_DAS_MENSAGENS", payload: data.user });
      }
    };

    socket.on("appMessage", onAppmessage);
    socket.on("user", onUser);

    return () => {
      socket.off("connect", onConnect);
			socket.off("appMessage", onAppmessage);
      socket.off("user", onUser);
      document.removeEventListener("visibilitychange", aoMudarVisibilidade);
    };
    // usuarioLogado entra aqui de proposito: o ouvinte usa o perfil para
    // decidir se mostra a nota do programador. Sem isto ele ficaria preso ao
    // valor do primeiro render, quando o usuario ainda nao carregou — e o
    // admin nunca veria nota nenhuma ao vivo.
  }, [ticketId, usuarioLogado?.profile]);

  const loadMore = () => {
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  };

  const scrollToBottom = () => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({});
    }
  };

  const handleScroll = (e) => {
    if (!hasMore) return;
    const { scrollTop } = e.currentTarget;

    if (scrollTop === 0) {
      e.currentTarget.scrollTop = 1;
    }

    if (loading) {
      return;
    }

    if (scrollTop < 50) {
      loadMore();
    }
  };

  const handleOpenMessageOptionsMenu = (e, message) => {
    setAnchorEl(e.currentTarget);
    setSelectedMessage(message);
  };

  const handleCloseMessageOptionsMenu = (e) => {
    setAnchorEl(null);
  };

  const checkMessageMedia = (message) => {
    if (message.mediaType === "location" && message.body.split('|').length >= 2) {
      let locationParts = message.body.split('|')
      let imageLocation = locationParts[0]
      let linkLocation = locationParts[1]

      let descriptionLocation = null

      if (locationParts.length > 2)
        descriptionLocation = message.body.split('|')[2]

      return <LocationPreview image={imageLocation} link={linkLocation} description={descriptionLocation} />
    }
    else if (message.mediaType === "vcard") {

      let array = message.body.split("\n");
      let obj = [];
      let contact = "";
      for (let index = 0; index < array.length; index++) {
        const v = array[index];
        let values = v.split(":");
        for (let ind = 0; ind < values.length; ind++) {
          if (values[ind].indexOf("+") !== -1) {
            obj.push({ number: values[ind] });
          }
          if (values[ind].indexOf("FN") !== -1) {
            contact = values[ind + 1];
          }
        }
      }
      return <VcardPreview contact={contact} numbers={obj[0]?.number} />
    }

    else if (ehFigurinha(message)) {
      return (
        <img
          className={classes.figurinha}
          src={message.mediaUrl}
          alt="figurinha"
        />
      );
    }

    else if (ehImagem(message)) {
      return <ModalImageCors imageUrl={message.mediaUrl} />;
    } else if (message.mediaType === "audio") {
      return (
        <Audio
          url={message.mediaUrl}
          fromMe={message.fromMe}
          contact={message.contact}
          autor={message.user}




          taxa={taxaAudio}
          onTaxa={alterarTaxaAudio}
        />
      );
    } else if (message.mediaType === "video") {
      return <VideoMensagem url={message.mediaUrl} classes={classes} />;
    } else {
      return <DocumentoMensagem url={message.mediaUrl} corpo={message.body} />;
    }
  };

  const shouldShowBody = (msg) => {
    if (!msg.body) return false;

    // Card de localizacao: LocationPreview ja desenha o mapa, endereco e botao
    if (msg.mediaType === "location") {
      return false;
    }

    if (msg.mediaUrl && /^\[[^\]]+\]$/.test(msg.body.trim())) {
      return false;
    }

    
    
    if (msg.mediaUrl) {
      const corpo = msg.body.trim();
      const nomeDoArquivo = String(msg.mediaUrl).split("/").pop() || "";
      if (
        corpo === nomeDoArquivo ||
        corpo === msg.mediaUrl.trim() ||
        /^[\w.-]+\.(jpe?g|png|gif|webp|bmp|mp4|mov|avi|pdf|docx?|xlsx?|zip)$/i.test(
          corpo
        )
      ) {
        return false;
      }
    }

    if (msg.mediaType === "audio") {
      const trimmed = msg.body.trim();
      const isAudioFilename =
        /^audio-.*\.(ogg|oga|opus|mp3|wav|m4a|aac)$/i.test(trimmed) ||
        /\.(ogg|oga|opus|mp3|wav|m4a|aac)$/i.test(trimmed) ||
        trimmed === msg.mediaUrl?.trim() ||
        trimmed.startsWith("audio-");
      if (isAudioFilename) return false;
    }
    return true;
  };

  const renderMessageAck = (message) => {
    if (message.ack === 0) {
      return <AccessTime fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 1) {
      return <Done fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 2) {
      return <DoneAll fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 3 || message.ack === 4) {
      return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />;
    }
  };

  const renderDailyTimestamps = (message, index) => {
    if (index === 0) {
      return (
        <span
          className={classes.dailyTimestamp}
          key={`timestamp-${message.id}`}
        >
          <div className={classes.dailyTimestampText}>
            {format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy")}
          </div>
        </span>
      );
    }
    if (index < messagesList.length - 1) {
      let messageDay = parseISO(messagesList[index].createdAt);
      let previousMessageDay = parseISO(messagesList[index - 1].createdAt);

      if (!isSameDay(messageDay, previousMessageDay)) {
        return (
          <span
            className={classes.dailyTimestamp}
            key={`timestamp-${message.id}`}
          >
            <div className={classes.dailyTimestampText}>
              {format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy")}
            </div>
          </span>
        );
      }
    }
    if (index === messagesList.length - 1) {
      return (
        <div
          key={`ref-${message.createdAt}`}
          ref={lastMessageRef}
          style={{ float: "left", clear: "both" }}
        />
      );
    }
  };

  const renderMessageDivider = (message, index) => {
    if (index < messagesList.length && index > 0) {
      let messageUser = messagesList[index].fromMe;
      let previousMessageUser = messagesList[index - 1].fromMe;

      if (messageUser !== previousMessageUser) {
        return (
          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }
    }
  };






  const irParaMensagem = (id) => {
    if (!id) return;

    const alvo = document.getElementById(`msg-${id}`);

    if (!alvo) {
      toast.info(
        "Essa mensagem ainda não foi carregada. Role a conversa para cima."
      );
      return;
    }

    alvo.scrollIntoView({ behavior: "smooth", block: "center" });




    alvo.classList.remove(classes.mensagemDestacada);


    void alvo.offsetWidth;
    alvo.classList.add(classes.mensagemDestacada);

    setTimeout(() => {
      alvo.classList.remove(classes.mensagemDestacada);
    }, 1400);
  };

  const renderQuotedMessage = (message) => {
    const citada = message.quotedMsg || {};

    const resumo = resumoDaCitacao(citada);
    const legenda = shouldShowBody(citada) ? citada.body : "";

    return (
      <div
        onClick={() => irParaMensagem(citada.id)}
        title="Ir para a mensagem"
        className={clsx(classes.quotedContainerLeft, classes.quotedClicavel, {
          [classes.quotedContainerRight]: message.fromMe,
        })}
      >
        <span
          className={clsx(classes.quotedSideColorLeft, {
            [classes.quotedSideColorRight]: citada.fromMe,
          })}
        ></span>

        <div className={classes.quotedMsg}>
          {!citada.fromMe && (
            <span className={classes.messageContactName}>
              {formatarNomeOuTelefone(
                citada.contact?.name,
                citada.contact?.number
              )}
            </span>
          )}

          {resumo ? (
            <span className={classes.quotedRotulo}>
              <resumo.Icone className={classes.quotedRotuloIcone} />
              {resumo.rotulo}
              {legenda ? `  ${legenda}` : ""}
            </span>
          ) : (
            citada.body
          )}
        </div>

        {citada.mediaType === "video" && citada.mediaUrl ? (




          <video
            className={classes.quotedMiniatura}
            src={citada.mediaUrl}
            preload="metadata"
            muted
            playsInline
          />
        ) : (
          temMiniaturaNaCitacao(citada) && (
            <img
              className={classes.quotedMiniatura}
              src={citada.mediaUrl}
              alt={resumo?.rotulo || "anexo"}
            />
          )
        )}
      </div>
    );
  };






  const temMidiaVisual = (msg) =>
    !!msg.mediaUrl &&
    !ehFigurinha(msg) &&
    (msg.mediaType === "image" || msg.mediaType === "video");




  const temAudio = (msg) => !!msg.mediaUrl && msg.mediaType === "audio";

  const renderMessages = () => {
    if (messagesList.length > 0) {
      const viewMessagesList = messagesList.map((message, index) => {
        if (!message.fromMe) {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <div
                id={`msg-${message.id}`}
                className={clsx(classes.messageLeft, {
                  [classes.bolhaComMidia]: temMidiaVisual(message),
                  [classes.bolhaFigurinha]: ehFigurinha(message),
                })}
              >
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {isGroup && (
                  <span className={classes.messageContactName}>
                    {message.contact?.name}
                  </span>
                )}
                {(message.mediaUrl || message.mediaType === "location" || message.mediaType === "vcard"
                  
                ) && checkMessageMedia(message)}
                <div
                  className={clsx(classes.textContentItem, {
                    [classes.textContentItemMidia]: temMidiaVisual(message),
                    [classes.textContentItemFigurinha]: ehFigurinha(message),
                    [classes.textContentItemAudio]: temAudio(message),
                  })}
                >
                  {message.quotedMsg && renderQuotedMessage(message)}
                  {ehComunicado(message) && (
                    <>
                      <span className={classes.comunicadoTitulo}>
                        📢 COMUNICADO
                      </span>
                      <span className={classes.comunicadoAutor}>
                        por {message.comunicadoAutor || "Equipe"}
                      </span>
                    </>
                  )}
                  {shouldShowBody(message) && (
                    <MarkdownWrapper>{message.body}</MarkdownWrapper>
                  )}
                  <span className={classes.timestamp}>
                    {format(parseISO(message.createdAt), "HH:mm")}
                  </span>
                </div>
              </div>
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <div
                id={`msg-${message.id}`}
                className={clsx(classes.messageRight, {
                  [classes.messageRightNota]: ehNotaInterna(message),
                  [classes.messageRightComunicado]: ehComunicado(message),
                  [classes.messageRightDev]: ehNotaDev(message),
                  [classes.bolhaComMidia]: temMidiaVisual(message),
                  [classes.bolhaFigurinha]: ehFigurinha(message),
                })}
              >
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {(message.mediaUrl || message.mediaType === "location" || message.mediaType === "vcard"
                  
                ) && checkMessageMedia(message)}
                <div
                  className={clsx(classes.textContentItem, {
                    [classes.textContentItemDeleted]: message.isDeleted,
                    [classes.textContentItemMidia]: temMidiaVisual(message),
                    [classes.textContentItemFigurinha]: ehFigurinha(message),
                    [classes.textContentItemAudio]: temAudio(message),
                  })}
                >
                  {message.isDeleted && (
                    <Block
                      color="disabled"
                      fontSize="small"
                      className={classes.deletedIcon}
                    />
                  )}
                  {message.quotedMsg && renderQuotedMessage(message)}
                    {ehComunicado(message) && (
                      <>
                        <span className={classes.comunicadoTitulo}>
                          📢 COMUNICADO
                        </span>
                        <span className={classes.comunicadoAutor}>
                          por {message.comunicadoAutor || "Equipe"}
                        </span>
                      </>
                    )}
                    {shouldShowBody(message) && (
                      <MarkdownWrapper>{message.body}</MarkdownWrapper>
                    )}
                  {}
                  {ehNotaDev(message) && message.devPayload && (
                    <button
                      type="button"
                      className={classes.linkDetalhes}
                      onClick={() => setDetalheDev(message)}
                    >
                      ver detalhes
                    </button>
                  )}
                  <span className={classes.timestamp}>
                    {format(parseISO(message.createdAt), "HH:mm")}
                    {renderMessageAck(message)}
                  </span>
                </div>
              </div>
            </React.Fragment>
          );
        }
      });
      return viewMessagesList;
    } else {
      return <div>Say hello to your new contact!</div>;
    }
  };











  const renderPendentes = () =>
    pendentesDoTicket.map((m) => {
      const podeReenviar =
        m.status === "falhou" || Date.now() - m.criadoEm > LIMITE_REENVIO_MS;

      return (
        <div
          key={m.tempId}
          className={clsx(classes.messageRight, classes.bolhaPendente)}
        >
          <div className={classes.textContentItem}>
            <MarkdownWrapper>{m.body}</MarkdownWrapper>

            {podeReenviar && (
              <div className={classes.avisoFalha}>
                <ErrorOutline style={{ fontSize: 14 }} />
                Não enviou.
                <button
                  type="button"
                  className={classes.botaoReenviar}
                  onClick={() => reenviar(m)}
                >
                  Enviar novamente
                </button>
              </div>
            )}

            <span className={classes.timestamp}>
              {format(new Date(m.criadoEm), "HH:mm")}
              <AccessTime fontSize="small" className={classes.ackIcons} />
            </span>
          </div>
        </div>
      );
    });

  return (
    <div className={classes.messagesListWrapper}>
      <MessageOptionsMenu
        message={selectedMessage}
        anchorEl={anchorEl}
        menuOpen={messageOptionsMenuOpen}
        handleClose={handleCloseMessageOptionsMenu}
      />
      <div
        id="messagesList"
        className={classes.messagesList}
        onScroll={handleScroll}
      >
        {messagesList.length > 0 ? renderMessages() : []}
        {renderPendentes()}
      </div>
      {loading && (
        <div>
          <CircularProgress className={classes.circleLoading} />
        </div>
      )}

      {}
      <Dialog
        open={Boolean(detalheDev)}
        onClose={() => setDetalheDev(null)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle style={{ paddingBottom: 4 }}>
          <div style={{ fontWeight: 700, fontSize: "0.95rem" }}>
            {detalheDev?.body}
          </div>
          <div style={{ fontSize: "0.74rem", opacity: 0.6, marginTop: 2 }}>
            Nota do programador ·{" "}
            {detalheDev
              ? format(parseISO(detalheDev.createdAt), "dd/MM/yyyy HH:mm")
              : ""}
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <pre className={classes.jsonCru}>{detalheDev?.devPayload}</pre>
        </DialogContent>
        <DialogActions style={{ padding: "12px 20px" }}>
          <Button
            onClick={() => {
              if (detalheDev?.devPayload) {
                navigator.clipboard?.writeText(detalheDev.devPayload);
              }
            }}
          >
            Copiar
          </Button>
          <Button variant="contained" color="primary" disableElevation onClick={() => setDetalheDev(null)}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MessagesList;


